import React, { FC } from "react";

interface DepartingFlightProps {
  className: string;
}

const DepartingFlight: FC<DepartingFlightProps> = ({ className }) => {
  return (
    <svg className={className}  xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" color="#66797F" width="24" height="24" ><path d="M2.25 20.25H15.75" stroke="#66797F" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.9913 15.7698L1.20951 12.988C1.12548 12.904 1.06262 12.8012 1.02611 12.6881C0.989598 12.575 0.980486 12.4549 0.999522 12.3376C1.01856 12.2202 1.0652 12.1091 1.13559 12.0134C1.20599 11.9177 1.29813 11.84 1.40443 11.7869L2.59503 11.1916L5.64443 12.1196L8.42867 10.6612L5.98248 8.21505C5.89845 8.13102 5.83559 8.02822 5.79908 7.91513C5.76257 7.80204 5.75346 7.68189 5.77249 7.56458C5.79153 7.44728 5.83817 7.33618 5.90857 7.24043C5.97896 7.14469 6.07111 7.06705 6.1774 7.0139L7.368 6.4186L13.2016 8.00959L17.3153 5.68446C17.8862 5.36181 18.547 5.23508 19.1967 5.32363C19.8464 5.41219 20.4492 5.71117 20.9128 6.17483L21.6385 6.90052C22.1067 7.36875 21.9988 8.15456 21.4217 8.4792L7.5834 16.2632C7.01283 16.5842 6.35294 16.7097 5.70438 16.6206C5.05582 16.5315 4.45421 16.2327 3.9913 15.7698Z" stroke="#66797F" stroke-linecap="round" stroke-linejoin="round"></path></svg>


  );
};

export default DepartingFlight;


